<template>
  <div
    class="
      h-full
      min-h-screen
      md:min-h-0
      flex flex-col
      bg-black
      md:overflow-y-scroll
      album
    "
    v-if="tracks.length > 0"
  >
    <NavMenu :isDark="true" />

    <header class="px-5 py-10 flex items-start absolute">
      <router-link
        class="w-15 h-15 cursor-pointer flex justify-center items-center"
        to="/search-tracks"
      >
        <Icon id="arrowLeft" />
      </router-link>
    </header>
    <div class="mb-8 pt-11">
      <img
        v-if="tracks[0].images[1]"
        class="mx-auto mb-6 h-72 w-72 md:h-80 md:w-80"
        :src="tracks[0].images[1].url"
      />
      <p class="text-white text-base text-center mb-4">
        {{ tracks[0].album_name }}
      </p>
      <span class="text-gray-300 text-base text-center block">{{
        tracks[0].release_date
      }}</span>
    </div>
    <div class="flex-1 px-4 pb-56 bg-black">
      <MusicCard
        v-for="(track, index) in tracks"
        :key="index"
        :isDisabled="isLimitReached"
        :title="track.name"
        :images="track.images"
        icon="dots"
        :numberSelection="trackIdsSelected.indexOf(track.id) + 1"
        :isSelected="trackIdsSelected.includes(track.id)"
        @onIcon="onTrackIcon(`/track/${track.id}`)"
        @click.native="onTrack(track.id)"
      />
    </div>
    <div
      v-if="trackIdsSelected.length < campaignTrackNormalMin"
      class="
        py-7
        px-6
        fixed
        bg-black
        flex flex-col
        left-0
        md:absolute
        bottom-0
        w-full
      "
    >
      <TrackCount v-if="trackIdsSelected.length < campaignTrackNormalMin" />
    </div>
    <div
      v-if="trackIdsSelected.length >= campaignTrackNormalMin"
      class="px-10 py-12 fixed bg-black left-0 md:absolute bottom-0 w-full"
    >
      <router-link
        :to="campaignIsSetlist ? '/breaker/opening' : '/playlist-sort'"
      >
        <Button :title="$t('searchTracksAdd')" />
      </router-link>
      <div class="mt-4 text-xs text-white text-center" v-if="isLimitReached">
        {{ $t("searchTracksLimit") }}
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { TranslationHandler } from '../../mixins/translation-handler'
import { RestTrack } from '../../types'
import { Component, Mixins } from 'vue-property-decorator'
import { Getter } from 'vuex-class'

@Component({
  components: {},
})
export default class Album extends Mixins(TranslationHandler) {
  @Getter campaignTracks!: RestTrack[]
  @Getter campaignIsSetlist!: boolean
  @Getter campaignTrackNormalMin!: number
  @Getter campaignTrackNormalLimit!: number

  get isLimitReached (): boolean {
    return this.campaignTrackNormalLimit === this.trackIdsSelected.length
  }

  get tracks (): RestTrack[] {
    const albumName = this.$route.params.name

    if (!albumName) {
      return []
    }

    return this.campaignTracks.filter((t) => t.album_name === albumName)
  }

  get trackIdsSelected (): number[] {
    return this.$store.getters.campaignTrackIdsSelected
  }

  set trackIdsSelected (data: number[]) {
    this.$store.commit('SET_CAMPAIGN_TRACK_IDS_SELECTED', data)
  }

  onTrackIcon (url: string) {
    this.$router.push(url)
  }

  onTrack (id: number) {
    if (this.trackIdsSelected.includes(id)) {
      this.trackIdsSelected.splice(this.trackIdsSelected.indexOf(id), 1)
    } else {
      if (this.isLimitReached) return

      this.trackIdsSelected.push(id)
    }
  }
}
</script>
